import React, { useEffect, useState } from "react";
import axiosInstance from "../components/api/axiosInstance";

function PortalDomainSelect({ value, onChange }) {
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      try {
        const res = await axiosInstance.get("/client/domains");
        if (active) {
          setDomains(Array.isArray(res.data?.data) ? res.data.data : []);
        }
      } catch (_) {
        if (active) setDomains([]);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  const hasCurrentValue =
    value &&
    !domains.some(
      (d) => String(d.Domain_Name || d.domain_name || "") === String(value)
    );

  return (
    <div className="cportal-field">
      <label>Business</label>
      <select value={value || ""} onChange={(e) => onChange(e.target.value)} disabled={loading}>
        <option value="">Select business</option>
        {hasCurrentValue && <option value={value}>{value}</option>}
        {domains.map((domain) => {
          const id = domain.Domain_Id ?? domain.domain_id;
          const name = domain.Domain_Name ?? domain.domain_name ?? "";
          return (
            <option key={id} value={name}>
              {name}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default PortalDomainSelect;
